module.exports = __webpack_public_path__ + "img/1970East-029_WEB-min.a504f206.jpg";